import { Component, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { ClientFaceDetail, FaceDetail, toClientFace, FaceDiffusion, toWancomFace, WancomCampaign, WancomFaces, ClientFaceDiffusion } from '../../park.model';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { CampaignService, DiffusionPriority } from '../../../private-campaign/services/campaign.service';
import { Router } from '@angular/router';
import { WaitingService } from '../../../layout/waiting/waiting.service';
import { AlertService } from '../../../../services/alert/alert.service';
import { UserAuthService } from '../../../../services/user/user-auth.service';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { DateTime } from 'luxon';
import { SpotCardComponent } from './spot-card/spot-card.component';
import { DragDropModule } from '@angular/cdk/drag-drop';

@Component({
    selector: 'app-diffusion-list',
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        MatCardModule,
        MatExpansionModule,
        SpotCardComponent,
        DragDropModule
    ],
    templateUrl: './diffusion-list.component.html',
    styleUrl: './diffusion-list.component.scss'
})
export class DiffusionListComponent {
    //#region Variables
    /**
     * Type d'écran
     */
    @Input() public type: 'Wancom' | 'Client' | 'Unknown';
    /**
     * Détail de la face
     */
    @Input() public face: FaceDetail;
    /**
     * détail de la campagne (Si écran Wancom)
     */
    @Input() public campaign?: WancomCampaign = null;
    @Output() public diffusionsDeleted = new EventEmitter<ClientFaceDiffusion>();
    @Output() public diffForScreenDeleted = new EventEmitter<{ diffusion: ClientFaceDiffusion, faceId?: number }>();
    /**
     * Expanders de l'écran
     */
    @ViewChildren(MatAccordion) allExpanders: QueryList<MatAccordion>;
    loaded: boolean;

    //#endregion Variables

    // MARK: CONSTRUCTOR
    constructor(
        private readonly router: Router,
        private readonly waiting$: WaitingService,
        private readonly alert$: AlertService,
        private readonly privateCampaign$: CampaignService,
        public userAuth$: UserAuthService
    ) { }

    /**
     * redirection pour ajouter une nouvelle diffusion Wanview
     *
     * @param faceId Id de la face
     */
    addNew(faceId?: number) {
        let url: string =
            faceId != null
                ? `spots/selectmethod?faceId=${faceId}&isPrivate=true`
                : `spots/selectmethod?isPrivate=true`;

        this.router.navigateByUrl(url);
    }

    /**
     *
     * @param campaign campagne dans laquelle on ajoute une diffusion
     */
    addDiffusionWancom(campaign: WancomCampaign, faceId?: number) {
        this.loaded = false;

        // Get default diffusion
        let defaultDiff: FaceDiffusion = campaign.diffusions.find(
            (diff: FaceDiffusion) => {
                return diff.isDefault;
            }
        );

        if (defaultDiff == null) {
            this.alert$.show({
                message:
                    'Erreur, cet écran ne possède pas de diffusion par défault.',
                duration: 5000,
            });
            this.loaded = true;
            return;
        }

        //Create new diffusion

        const waitingId: string = this.waiting$.start();

        this.privateCampaign$
            .createDiffusion({
                beginDate: campaign.date.start,
                endDate: campaign.date.end,
                weekDays: [],
                diffusionPriority: DiffusionPriority.Middle,
                id: null,
                defaultDiffusionId: defaultDiff.diffusionId,
            })
            .subscribe({
                next: (newDiffId) => {
                    this.waiting$.end(waitingId);
                    let url: string = `spots/selectmethod?diffusionId=${newDiffId.diffusionId}&newDiff=true`;
                    url +=
                        campaign.duration != null
                            ? `&duration=${campaign.duration}`
                            : '';
                    url += faceId != null ? `&faceId=${faceId}` : '';

                    this.router.navigateByUrl(url);
                },
                error: (err) => {
                    this.waiting$.end(waitingId);
                    console.error(err);
                    this.loaded = true;
                },
            });
    }

    getCurrentNbDiff(diffs: FaceDiffusion[]) {
        let nbCurrDiffs: number = 0;

        const today: DateTime = DateTime.now();



        diffs.forEach(currDiff => {
            if (DateTime.fromISO(currDiff.startDate) <= today && DateTime.fromISO(currDiff.endDate) >= today) {
                nbCurrDiffs++
            }

        });
        return nbCurrDiffs;

    }

    public toWancomFace(face: FaceDetail): WancomFaces {
        return toWancomFace(face);
    }

    public toClientFace(face: FaceDetail): ClientFaceDetail {
        return toClientFace(face);
    }

    public deleteDiff(diffusion: ClientFaceDiffusion) {
        this.diffusionsDeleted.emit(diffusion);
    }

}
